import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnInit {

  private tokenKey = 't';
  private tokenParam: string;

  constructor() { }

  ngOnInit() { }

}
